import { createEntityAdapter } from "@reduxjs/toolkit";
import { Sheet } from "./dataTypes";

export const sheetAdapter = createEntityAdapter<Sheet>({});
